import React, { useState, useEffect } from 'react';
import wrapStore from '@src/utils/wrap-store';
import ArticleStore from './store';
import Link from '@src/components/link';
import cx from 'classnames';

import xauCss from '@src/components/xfe-animation-css';

const styles = require('./index.less');

const Article2 = ({ store }) => {
  store.use();
  const [activeAnchor, setActiveAnchor] = useState('');
  const [showSidebar, setShowSidebar] = useState(false);

  const scrollToAnchor = anchorId => {
    const element = document.getElementById(anchorId);
    if (element) {
      const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
      const offset = 50; // 向上的偏移值
      window.scrollTo({ top: elementTop - offset, behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const anchors = ['战域云顶', '玩法介绍', '活动奖励', '玩法调整', '战域统战', '战域匹配'];
    const handleScroll = () => {
      let currentActive = '';
      for (const id of anchors) {
        const element = document.getElementById(id);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 200) {
            currentActive = id;
          }
        }
      }
      setActiveAnchor(currentActive);

      const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
      const threshold = (960 / 192) * rootFontSize;
      setShowSidebar(window.scrollY >= threshold);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.article}>
      <div className="xfe-group-1" data-name="内容">
        <div className={cx('xfe-layer-3', { ...xauCss.FADE.IN_UP() })} />
        <div className={cx('xfe-group-2', { ...xauCss.FADE.IN_UP() })} data-name="顶部导航条">
          <div className="xfe-layer-4" />
          <div className="xfe-group-3" data-name="组 83">
            <Link className="xfe-layer-5" data-id={'战域云顶'} onClick={() => scrollToAnchor('战域云顶')} />
            <Link className="xfe-layer-6" data-id={'玩法介绍'} onClick={() => scrollToAnchor('玩法介绍')} />
            <Link className="xfe-layer-7" data-id={'活动奖励'} onClick={() => scrollToAnchor('活动奖励')} />
            <Link className="xfe-layer-8" data-id={'玩法调整'} onClick={() => scrollToAnchor('玩法调整')} />
            <Link className="xfe-layer-9" data-id={'战域统战'} onClick={() => scrollToAnchor('战域统战')} />
            <Link className="xfe-layer-10" data-id={'战域匹配'} onClick={() => scrollToAnchor('战域匹配')} />
          </div>
        </div>

        <div className={cx('xfe-group-4', { visible: showSidebar })} data-name="侧栏导航">
          <div className="xfe-layer-11" />
          <div className="xfe-group-5" data-name="组 35">
            <Link className={cx('xfe-group-10', { active: activeAnchor === '战域云顶' })} data-name="战域云顶" onClick={() => scrollToAnchor('战域云顶')}>
              <div className="xfe-layer-20" />
              <div className="xfe-layer-21" />
            </Link>

            <Link className={cx('xfe-group-6', { active: activeAnchor === '玩法介绍' })} data-name="玩法介绍" onClick={() => scrollToAnchor('玩法介绍')}>
              <div className="xfe-layer-12" />
              <div className="xfe-layer-13" />
            </Link>

            <Link className={cx('xfe-group-7', { active: activeAnchor === '活动奖励' })} data-name="活动奖励" onClick={() => scrollToAnchor('活动奖励')}>
              <div className="xfe-layer-14" />
              <div className="xfe-layer-15" />
            </Link>

            <Link className={cx('xfe-group-8', { active: activeAnchor === '玩法调整' })} data-name="玩法调整" onClick={() => scrollToAnchor('玩法调整')}>
              <div className="xfe-layer-16" />
              <div className="xfe-layer-17" />
            </Link>

            <Link className={cx('xfe-group-9', { active: activeAnchor === '战域统战' })} data-name="战域统战" onClick={() => scrollToAnchor('战域统战')}>
              <div className="xfe-layer-18" />
              <div className="xfe-layer-19" />
            </Link>
            <Link className={cx('xfe-group-11', { active: activeAnchor === '战域匹配' })} data-name="战域匹配" onClick={() => scrollToAnchor('战域匹配')}>
              <div className="xfe-layer-22" />
              <div className="xfe-layer-23" />
            </Link>

            <Link className="xfe-group-12" data-name="返回顶部 " onClick={scrollToTop}>
              <div className="xfe-layer-24" />
              <div className="xfe-layer-25" />
            </Link>
          </div>
        </div>

        <div className={cx('xfe-group-content', { ...xauCss.FADE.IN_DOWN() })} data-name="内容区" dangerouslySetInnerHTML={{ __html: store.content }} />
      </div>
    </div>
  );
};

export default wrapStore(Article2, ArticleStore);
